import JsxContent from 'ms-components/JsxContent';

import { FreeTextbooksTeaserContent } from '../FreeTextbooksTeaserContent';

export function FreeTextbookWorksheet({ jsxContent }: { jsxContent: string }) {
  return (
    <FreeTextbooksTeaserContent
      title="Sign up to access Worksheet"
      snowplowEventLabel="worksheet_access"
    >
      <JsxContent transpiledJsx={jsxContent} />
    </FreeTextbooksTeaserContent>
  );
}
